export default __webpack_public_path__ + "static/responsive-243cc01d0b453f11e762abe79377d982.svg";